// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__39qCG","text":"styles_text__2yQg5","date":"styles_date__3agUS"};